// extracted by mini-css-extract-plugin
export default {"buttonNext":"ButtonNext_buttonNext__6tjIp"};